<template>
  <div v-if="getPermission.settings.view || getPermission.stc.view">  

    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">

          <div v-if="active" class="md-layout-item md-size-15 ">
           <div class = "inputBox">
              <datepicker v-model="searchRequest.billingDate.startDate">
                <label>Doc Date From</label>
              </datepicker>
            </div>
          </div>

          <div v-if="active" class="md-layout-item md-size-15 ">
           <div class = "inputBox">
              <datepicker v-model="searchRequest.billingDate.endDate">
                <label>Doc Date To</label>
              </datepicker>
            </div>
          </div>


          <div v-if="active" class="md-layout-item md-size-15 ">
           <div class = "inputBox">
              <md-field>
                <label size="lg" class = "textlabel" for="docType" >Status</label>
                  <md-select v-model="searchRequest.billingStatus">
                  <md-option value="BLC">BLC Cost Confirm</md-option>
                  <md-option value="LOK">LOK Cost Locked</md-option>
                </md-select>
              </md-field>
            </div>
          </div>
 

          <div v-if="active" class="md-layout-item md-size-15 ">
            <div class = "inputBox">
              <md-field>
                <label>Container#</label>
                <md-input v-model="searchRequest.containerNo"/>
              </md-field>
            </div>
          </div>  

          <div v-if="active" class="md-layout-item md-size-15 ">
            <div class = "inputBox">
              <md-field>
                <label>Load#</label>
                <md-input v-model="searchRequest.seqNo"/>
              </md-field>
            </div>
          </div>  

          <div v-if="active" class="md-layout-item md-size-15 ">
            <div class = "inputBox">
              <md-field>
                <label>Batch#</label>
                <md-input v-model="searchRequest.batchNum"/>
              </md-field>
            </div>
           </div> 

          <div v-if="active" class="md-layout-item md-size-15 ">
            <div class = "inputBox">
              <md-field>
                <label>Payroll#</label>
                <md-input v-model="searchRequest.payrollNum"/>
              </md-field>
            </div>
           </div> 

          <div v-if="active" class = "md-layout-item md-size-35">
            <auto-complete-master-data-select
              group="STC_DRIVER_COMPANY"
              label="Driver Company"
              :on-item-changed="handleDriverCompanyChanged">
            </auto-complete-master-data-select>
          </div>
          



          <div v-if="getPermission.ccic.edit || getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100">
            <callingApiCenter :paths="['/api/w/apar/stagelist']">
              <callingApiCenter path="/api/w/apar/stagelist" :not-display-error="true">
                <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-special-form-container md-primary md-raised" ><span class="icons-center material-icons">search</span>Search</md-button>
                <md-button class="md-raised custButton md-primary" v-if="searchRequest.lockUnlock == 'BLC'" @click="doLock" :disabled="!this.getPermission.stcMgtLock.edit && !this.getPermission.stcAcctLock.edit"><span class="icons-center material-icons">lock</span>Lock</md-button>
                <md-button class="md-raised custButton md-accent" v-if="searchRequest.lockUnlock == 'LOK'" @click="doUnLock" :disabled="!this.getPermission.stcMgtLock.edit && !this.getPermission.stcAcctLock.edit"><span class="icons-center material-icons">lock_open</span>UnLock</md-button>
                <md-button class="md-raised custButton" @click="doClear">Clear</md-button>
                <input class = "custSearchBar" @input="clearSelect" type="text"
                        placeholder="Filter Search"
                        v-model="filter"
                        />
              <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
                <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
              </md-button>
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>


    <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                    <tr>
                      <th class="header-cell w2">
                        <md-checkbox v-model="selectAll" @change="changeSelChkBox"></md-checkbox>
                        <md-tooltip md-direction="top">All</md-tooltip>
                      </th>
                      <th class="header-cell center w6" v-on:click="sortFunction('payrollNum')">Payroll#</th>
                      <th class="header-cell center w6" v-on:click="sortFunction('batchNum')">Batch</th>
                      <th class="header-cell center w6" v-on:click="sortFunction('driverCompany')">Dr.Company</th> 
                      <th class="header-cell center w5" v-on:click="sortFunction('partner')">Partner</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('containerNo')">CTNR</th>
                      <th class="header-cell center w6" v-on:click="sortFunction('refDoc')">RefDoc#</th>
                      <th class="header-cell center w4" v-on:click="sortFunction('billingDate')">Doc Date</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('amt')">Amt</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('qty')">Qty</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('tol')">Tol</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('pickupLocationCode')">Pickup</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('deliverLocationCode')">Dropoff</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('driverType')">Dr.Type</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('stageBookingNo')">BL/BKing</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('inGateDate')">InGate</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('chzStartDate')">OutGate</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('rdesc')">Rate Desc</th>
                      <th class="header-cell center w6" v-on:click="sortFunction('billingNumRateType')">Doc RateType</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('pf')">PF</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load#</th>
                      <th class="header-cell center w2" v-on:click="sortFunction('stageType')">Stage</th>
                      <th class="header-cell center w5" v-on:click="sortFunction('settleDate')">SettleDate</th>
                    </tr>  
                  </thead>
                </table>
              </div>

              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" 
                          v-bind:class ="{ selected: item.selected }">
                      <td class="body-cell w2 ">
                        <md-checkbox v-model="item.selected">
                          <!-- <span v-if="hasBeenChanged(item)">*</span> -->
                        </md-checkbox>
                      </td>
                      <td class="body-cell excelBox w6">{{item.payrollNum}}</td>
                      <td class="body-cell excelBox w6">{{item.batchNum}}</td>
                      <td class="body-cell excelBox w6"><master-data-display group="STC_DRIVER_COMPANY" :tag-id="item.driverCompany"/></td> 
                      <td class="body-cell excelBox w5">{{item.partner}}</td>
                      <td class="body-cell excelBox w5">{{item.containerNo}}</td>
                      <td class="body-cell excelBox w6">{{item.refDoc}}</td> 
                      <td class="body-cell excelBox w4">{{item.billingDate | date}}</td>
                      <td class="body-cell excelBox w2">{{item.amt}}</td>
                      <td class="body-cell excelBox w2">{{item.qty}}</td>
                      <td class="body-cell excelBox w2">{{item.tol}}</td>
                      <td class="body-cell excelBox w5">{{item.pickupLocationCode}}</td>
                      <td class="body-cell excelBox w5">{{item.deliverLocationCode}}</td>
                      <td class="body-cell excelBox w2">{{item.driverType}}</td>
                      <td class="body-cell excelBox w5">{{item.stageBookingNo}}</td>
                      <td class="body-cell excelBox w5">{{item.inGateDate | date}}</td>
                      <td class="body-cell excelBox w5">{{item.chzStartDate | date}}</td>
                      <td class="body-cell excelBox w5">{{item.rdesc}}</td> 
                      <td class="body-cell excelBox w6">{{item.billingNumRateType}}</td>
                      <td class="body-cell excelBox w2">{{item.pf}}</td> 
                      <td class="body-cell excelBox w5">{{item.seqNo}}</td>  
                      <td class="body-cell excelBox w2">{{item.stageType}}</td>
                      <td class="body-cell excelBox w5">{{item.settleDate | date}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
  </div>
</template>

<style scoped>
.icons-center {
      vertical-align: middle;
      margin-right: 10px;
      color: rgb(190, 243, 141);
  }

  .inputBox {
      border: 1px solid #cacbcc;
      border-radius: 5px;
      color: #29303b;
      font-size: 18px;
      height: auto;
      line-height: 1.5em;
      padding: 5px 5px 5px 5px;
      margin-top: 5px;
  }

  .selected {
      background: rgb(190, 243, 141);
  }

  .center {
      text-align: center;
  }

  .custButton {
      margin: 10px;
      width: 120px;
      height: 40px;
      line-height:40px;
      font-size: 0.8rem;
  }

  .custSearchBar{
      margin: 10px;
      width: 200px;
      height: 40px;
      line-height:40px;
      font-size: 0.9rem;
      color: blue;
  }

  .custButtonRight {
      margin: 10px;
      width: 100px;
      height: 40px;
      float : right;
      color: green;
  }
</style>


<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  //import api from "../api";
  import { newAPIPost } from '../api';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";


  const getInitSearch = () => ({
    salesOffice: "LGB",
    docType: "STAGE",
    // billingNum: null,
    // deliveryOrder: null,
    // customerPO: null,
    payrollNum: null,
    batchNum: null,
    seqNo: null,
    // refDoc: null,
    containerNo: null,
    // agreement: null,
    billingStatus: "BLC",
    selected: false,
    lockUnlock: "BLC",
    billingDate: {
      startDate: moment().subtract(1,'months').startOf('d').toDate(),
      endDate: moment().add(0,'months').endOf('d').toDate(),
    },
  });

  export default {
    data: () => ({
      searchRequest: getInitSearch(),
      active: true,
      items: [],
      sortStatus: true,
      filter:"",
      selectAll: false,
    }),

    components: {
      AutocompleteCcicLocationSelect,
      callingApiCenter,
    },

    watch: {
      getlockstage(val) {
        this.updateItems(val);
      },
    },

    computed: {
      ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getlockstage',
      ]),

      filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(row.payrollNum).includes(term) ||
                  this.includeNull(row.batchNum).includes(term) ||
                  this.includeNull(row.partner).includes(term) ||
                  this.includeNull(row.containerNo).includes(term) ;
        })
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },
    },

    async mounted() {
      const cachedSearchRequest = this.$store.state.lockstage.searchRequest;
      this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
      this.searchRequest.billingDate.startDate = moment().subtract(1,'months').startOf('d').toDate();
      this.searchRequest.billingDate.endDate = moment().add(1,'days').endOf('d').toDate();
      this.searchRequest.salesOffice = 'LGB' ; 
      this.$el.querySelector('#searchTag').click();
      this.updateItems(this.getlockstage);
    },

    methods: {
      mouseOver: function(){
          this.active = true;
      },
      mouseLeave: function() {
        this.active = !this.active;
      },

      handleDriverCompanyChanged(id){
        this.searchRequest.driverCompany = id;
      },

      sortFunction(sortFiled){
        const sorted = _(this.items).sortBy(sortFiled);
        console.log(this.sortStatus)
        this.sortStatus = !this.sortStatus;
        if (this.sortStatus)
        {
            this.items = sorted;
        }
        else
        {
            this.items = sorted.reverse();
        }
      },

      changeSelChkBox() { 
        _(this.filteredRows).forEach(
          it => {
            it.selected = this.selectAll;
          }
        );
        this.updateItems(this.items);
     },

    clearSelect() { 
      this.selectAll = false; 
      _(this.filteredRows).forEach(it => {it.selected = false; });
      this.updateItems(this.items);
    },

      updateItems(itemsSource) {
        var items = JSON.parse(JSON.stringify(itemsSource)) ;
        items.forEach((it) => {
          it.selected ;
        });
        this.items = items;         
      },

      doLock() {
        const load = this.uniqByLast(this.getSelectedItems, it => it.refDoc);
        const apar = this.uniqByLast(this.getSelectedItems, it => it.billingNumRateType);
        //api.post("/api/w/apar/confirm",
        newAPIPost("/api/w/apar/confirm", 
        {
          mode: 'stageLock',
          username: this.getUserProfile.username,
          refList: load.map(it => {
            return {
              refDoc: it.refDoc
            }
          }),
          apar: apar.map(it => {
            return {
              billingNumRateType: it.billingNumRateType
            }
          })
        }
        ).then((res) => {
          this.showDialog = false;
          this.$store.commit("clearApiError");
          this.doSearch();
          window.confirm(res);
        });
      },

      doUnLock() {
        const load = this.uniqByLast(this.getSelectedItems, it => it.refDoc);
        const apar = this.uniqByLast(this.getSelectedItems, it => it.billingNumRateType);
        //api.post("/api/w/apar/confirm",
        newAPIPost("/api/w/apar/confirm", 
        {
          mode: 'stageUnLock',
          username: this.getUserProfile.username,
          refList: load.map(it => {
            return {
              refDoc: it.refDoc
            }
          }),
          apar: apar.map(it => {
            return {
              billingNumRateType: it.billingNumRateType
            }
          })
        }
        ).then((res) => {
          this.showDialog = true;
          this.$store.commit("clearApiError");
          this.doSearch();
          window.confirm(res);
        });
      },

      doSearch() {
        this.active = true;
        this.selectAll = false; 
        if (this.searchRequest.billingDate.startDate == null)
        {
          window.confirm('Doc Date From is required!')
          return;
        }
        if (this.searchRequest.billingDate.endDate == null)
        {
          window.confirm('Doc Date To is required!')
          return;
        }

        this.$store.dispatch('lockstage', this.searchRequest);
        if (this.searchRequest.billingStatus == "BLC" ){
          this.searchRequest.lockUnlock = "BLC";
        };

        if (this.searchRequest.billingStatus == "LOK" ){
          this.searchRequest.lockUnlock = "LOK";
        };
        this.searchRequest.salesOffice = 'LGB';
       },


      doClear(){
        this.filter = "";
        this.searchRequest = getInitSearch();
        var items = JSON.parse(JSON.stringify(this.items));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
      },

      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },

      uniqByLast(data, key){
        return [
          ...new Map(
            data.map(x => [key(x), x])
          ).values()
        ]
      },

      includeNull(field){
            return field==null ? '' : field;
        },
     },
    }
</script>